import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

export default function ArticleCard({
  article,
  horizontal = false,
}: {
  article: Article;
  horizontal?: boolean;
}) {
  if (horizontal) {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row sm:p-4"
      >
        <div className="relative h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-28 sm:w-40">
          <img
            src={article.cover}
            alt={article.title}
            title={`${article.title} - 可游漫画网`}
            className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          />
          <span className="manga-clip absolute left-0 top-3 bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
            {article.tag}
          </span>
        </div>
        <div className="flex flex-1 flex-col justify-between">
          <div>
            <h4 className="font-heading text-base leading-snug text-foreground-950 group-hover:text-primary-600">
              {article.title}
            </h4>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
              {article.excerpt}
            </p>
          </div>
          <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1"><i className="ri-calendar-line" />{article.date}</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line" />{article.views.toLocaleString()}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-primary-300"
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 可游漫画网`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className="manga-clip absolute left-0 top-3 bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
          {article.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h4 className="font-heading text-base leading-snug text-foreground-950 group-hover:text-primary-600">
          {article.title}
        </h4>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1"><i className="ri-calendar-line" />{article.date}</span>
          <span className="flex items-center gap-1"><i className="ri-eye-line" />{article.views.toLocaleString()}</span>
        </div>
      </div>
    </Link>
  );
}